import { render, staticRenderFns } from "./delivery-summary-stats.vue?vue&type=template&id=4a164b86&scoped=true&"
import script from "./delivery-summary-stats.vue?vue&type=script&lang=js&"
export * from "./delivery-summary-stats.vue?vue&type=script&lang=js&"
import style0 from "./delivery-summary-stats.vue?vue&type=style&index=0&id=4a164b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a164b86",
  null
  
)

export default component.exports